export const DESCRIPTOR = {
  API: 'delning',
  INSIGHT_STUDIO: 'dashboard'
}
